module.exports = __webpack_public_path__ + "static/media/logo.19bf4913.png";